import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-custom-column',
    standalone: false,
    templateUrl: './custom-column.component.html',
    styleUrl: './custom-column.component.scss'
})
export class CustomColumnComponent {
    @Input() columnDetails: any;
    @Input() rowData: any;
    @Input() entity: any;
    @Output() componentEvent: EventEmitter<any> = new EventEmitter<any>();

    protected SHG_STATUS_INFO: any = '';
    geoLocation: any;
    constructor() {
        // this.geoLocation = this.appSettingService.getConfig('geoLocation');
        this.geoLocation = '';
    }

    getLocation() {
        if (this.rowData.block && this.rowData.block !== '-') {
            const block = this.geoLocation.find((item: any) => item.block_id === `B-${this.rowData.block}`);
            if (block) {
                return `<b>State:</b>&nbsp;${block.state_name}
        <b>District:</b>&nbsp;${block.district_name}
        <b>Block:</b>&nbsp;${block.block_name}`;
            }
        }
        if (this.rowData.district && this.rowData.district !== '-') {
            const district = this.geoLocation.find((item: any) => item.district_id === `D-${this.rowData.district}`);
            if (district) {
                return `<b>State:</b>&nbsp;${district.state_name}
        <b>District:</b>&nbsp;${district.district_name}`;
            }
        }
        if (this.rowData.state && this.rowData.state !== '00') {
            const state = this.geoLocation.find((item: any) => item.state_id === `S-${this.rowData.state}`);
            if (state) {
                return `<b>State:</b>&nbsp;${state.state_name}`;
            }
        }
        return '';
    }

    clickedOnImage(column: any, rowData: any) {
        this.componentEvent.emit({ column: column, rowData: rowData });
    }
    getFormattedDate(date: string): string {
        if (!date) return '';
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        return new Date(date).toLocaleDateString('en-IN', options);
    }

    formatNumberRanges(numbers: any[]): string {
        if (!numbers.length) return '';
        const sorted = [...numbers].sort((a, b) => a - b);
        const result: string[] = [];
        let start = sorted[0];
        let prev = start;

        for (let i = 1; i <= sorted.length; i++) {
            const current = sorted[i];
            if (current !== prev + 1 || i === sorted.length) {
                if (start === prev) {
                    result.push(`${start}`);
                } else {
                    result.push(`${start}-${prev}`);
                }
                start = current;
            }
            prev = current;
        }
        return result.join(',');
    }
}
